import { RadioGroup } from "@headlessui/react";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { RadioButtonOption } from "@/components/Interface/FormFields/RadioButton/RadioButton";
import { FilterDialogForm } from "@/components/Portal/components/PortalDeviceListFilter/types";
import { GetSimListSimAutoRenew } from "@/services/model";

export const Settings = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<FilterDialogForm>;
  watch: UseFormWatch<FilterDialogForm>;
}) => {
  const { t } = useTranslation("portal");

  const mobileAboOptions: {
    state: GetSimListSimAutoRenew | "ALL";
    label: string;
  }[] = [
    { state: "ALL", label: t("cockpit.filter.activity-labels.all") },
    { state: "ACTIVE", label: t("cockpit.filter.activity-labels.active") },
    { state: "INACTIVE", label: t("cockpit.filter.activity-labels.inactive") },
  ];

  return (
    <RadioGroup
      value={watch("simAutoRenew")}
      onChange={(value: "ALL" | "ACTIVE" | "INACTIVE") =>
        setValue("simAutoRenew", value)
      }
    >
      <RadioGroup.Label className="mb-6 block text-sm font-semibold tracking-wide">
        {t("cockpit.filter.activity-labels.mobileAbo")}
      </RadioGroup.Label>
      <div className="flex flex-wrap gap-6">
        {mobileAboOptions.map((opt) => (
          <RadioButtonOption
            key={opt.state}
            name="simAutoRenew"
            value={opt.state}
            label={opt.label}
            inverted
          />
        ))}
      </div>
    </RadioGroup>
  );
};
